<div class="container-xl">
    <div class="titration-plan-section">
        <div class="titration-plan-form">
            <div class="titration-plan-form-row">
                <strong>Einstellungen</strong>
                <div class="icon mr-0" (click)="fnShowRechnerInfoPopup(0)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
            </div>

            <div class="titration-plan-form-row produktauswahl full-width-input">
                <div class="icon" (click)="fnShowRechnerInfoPopup(1)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>{{ProductTHCText}}</span>
                </div>
                <div class="form-row-input">
                    <ng-container *ngIf="isPrivatePage">
                        <select class="form-control-sm" [(ngModel)]="productNameInput" (change)="inputChangeProduct()">
                            <ng-container *ngFor="let item of productList">
                                <option [value]="item.ProductName">{{item.ProductName}}</option>
                            </ng-container>
                        </select>
                    </ng-container>
                    <ng-container *ngIf="!isPrivatePage">
                        <select class="form-control-sm" [(ngModel)]="thcKonzentrationInput" (change)="inputChange('THC Konzentration',thcKonzentrationInput)">
                            <ng-container *ngFor="let item of thcKonzentrationList">
                                <option [value]="item.ProductName">{{item.ProductName}}</option>
                            </ng-container>
                        </select>
                    </ng-container>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(2)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Dosierungsart</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="artDerDorierungInput" (change)="inputChange('Dosierungsart',artDerDorierungInput)">
                        <ng-container *ngFor="let item of artDerDorierungList">
                            <option [value]="item.value">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(1)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Verschreibungsmenge</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="verschreibungsmengeInput" (change)="inputChange('Verschreibungsmenge',verschreibungsmengeInput)">
                        <ng-container *ngFor="let item of verschreibungsmengeList">
                            <option [value]="item.value">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(3)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Start Tagesdosis THC</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="startTageDosisInput" (change)="inputChange('Start Tagesdosis THC',startTageDosisInput)">
                        <ng-container *ngFor="let item of startTageDosisList">
                            <option [value]="item.milligram">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(4)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Dosissteigerung Tage</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="tageTitrierungInput" (change)="inputChange('Dosissteigerung Tage',tageTitrierungInput)">
                        <ng-container *ngFor="let item of tageTitrierungList">
                            <option [value]="item.tage">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(4)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Steigerung THC</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="steigerungDosisInput" (change)="inputChange('Steigerung THC',steigerungDosisInput)">
                        <ng-container *ngFor="let item of steigerungDosisList">
                            <option [value]="item.milligram">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(4)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Max. Tagesdosis THC</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="maximaleTageDosisTHCInput" (change)="inputChange('Max. Tagesdosis THC',maximaleTageDosisTHCInput)">
                        <ng-container *ngFor="let item of maximaleTageDosisTHCList">
                            <option [value]="item.mg">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row flex-column" *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY">
                <div class="form-row-text w-100 flex-row">
                    <div class="icon" (click)="fnShowRechnerInfoPopup(5)">
                        <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                    </div>
                    <p class="text-center mb-2 w-100">Dosierungsschema</p>
                </div>
                <div class="form-row-input w-100 flex-column">
                    <div class="preset-buttons">
                        <ng-container *ngFor="let button of presetButtonsList">
                            <div class="preset-button" [class.active]="button.value==selectedPresetButton?.value" (click)="onSelectPresetButton(button)">
                                {{button.title}}
                            </div>
                        </ng-container>
                    </div>

                    <div class="slider-rows">
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="morgensVal" [options]="dosierungsSchemaOptions('morgens')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('morgens',morgensVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>morgens</p>
                                <p>{{morgensPerDisplay}}%</p>
                            </div>
                        </div>
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="mittagsVal" [options]="dosierungsSchemaOptions('mittags')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('mittags',mittagsVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>mittags</p>
                                <p>{{mittagsPerDisplay}}%</p>
                            </div>
                        </div>
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="abendsVal" [options]="dosierungsSchemaOptions('abends')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('abends',abendsVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>abends</p>
                                <p>{{abendsPerDisplay}}%</p>
                            </div>
                        </div>
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="zurNachtVal" [options]="dosierungsSchemaOptions('zur Nacht')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('zur Nacht',zurNachtVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>zur Nacht</p>
                                <p>{{zurNachtPerDisplay}}%</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row-text w-100 slider-info">
                    <p>Verteilung</p>
                    <p>(Individuelle Anpassung möglich)</p>
                </div>
            </div>
        </div>
        <div class="titration-plan-block {{partnerName}}" id="titration-plan-block">
            <div class="header-section">
                <div class="header-content">
                    <h5>Titrationsplan</h5>
                    <div [innerHTML]="getHeaderContent()"></div>
                </div>
                <div class="header-button header-button-paitent">
                    <p>Patient:in:</p>
                </div>
                <div class="header-button header-button-icon">
                    <div class="print-view-close show-on-blank" onClick="javascript:window.close('','_parent','');">
                        <span>Druckansicht schließen</span>

                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52px" height="52px" viewBox="0 0 52 52" version="1.1">
                            <g id="DRuckansicht-Update-oct-2024" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Tilray---Druckansicht-Copy-4" transform="translate(-1445.000000, -167.000000)">
                                    <g id="Druckansicht-schließen" transform="translate(1277, 168.000000)">
                                        <path d="M170,0 L215,0 C217.761424,-5.07265313e-16 220,2.23857625 220,5 L220,45 C220,47.7614237 217.761424,50 215,50 L170,50 L170,50 L170,0 Z" id="Rectangle" fill="#C83232" />
                                        <g id="close" transform="translate(180.000000, 10.000000)">
                                            <circle id="Oval-Copy-4" fill="#FFFFFF" cx="15" cy="15" r="15" />
                                            <line x1="15" y1="6" x2="15" y2="24" id="Line-6-Copy-10" stroke="#C83232" stroke-width="2" stroke-linecap="round" transform="translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) " />
                                            <line x1="24" y1="15" x2="6" y2="15" id="Line-6-Copy-10" stroke="#C83232" stroke-width="2" stroke-linecap="round" transform="translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) " />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div class="header-button-icon-contianer button-on-blank">
                        <ul>
                            <li (click)="fnPrintPageData()">
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                        <img src="/images/private/titration/tilray/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <img src="/images/private/titration/hormosan/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <img src="/images/private/420pharma/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <img src="/images/private/titration/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                </ng-container>
                            </li>
                            <li (click)="fnShowRezeptPopup()">
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                        <img src="/images/private/titration/tilray/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <img src="/images/private/titration/hormosan/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <img src="/images/private/420pharma/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <img src="/images/private/titration/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="diagram-section">
                <div class="titrations-plan-chart">
                    <div id="titrationsPlanChart"></div>
                </div>
                <div class="climbing-steps">
                    <ng-container [ngSwitch]="partnerName">
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                            <img src="/images/private/titration/tilray/Titrationsplan erstellen.svg" alt="Titrationsplan erstellen.svg" />
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                            <img src="/images/private/titration/hormosan/Icon_Titration_Hormosan_Transparent.svg" alt="Titrationsplan erstellen.svg" />
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                            <img src="/images/private/420pharma/Titrationsplan erstellen.svg" alt="Titrationsplan erstellen.svg" />
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <img src="/images/private/titration/Titrationsplan erstellen.svg" alt="Titrationsplan erstellen.svg" />
                        </ng-container>
                    </ng-container>
                    <p>Die Steigerung der Dosierung findet in Stufen über mehrere Tage statt. Der optimale Dosisbereich ist in der Stufe erreicht, in der eine gewünschte Symptomlinderung ohne unangenehme Nebenwirkungen erzielt wird.</p>
                </div>
            </div>
            <div class="content-section">
                <div class="content-accordion" [class.active]="expandedContent">
                    <div class="content-accordion-header" (click)="expandedContent=!expandedContent">
                        <div>Gebrauchsanweisung für den/die Patient:in</div>
                    </div>
                    <div class="content-accordion-description">
                        <div class="accordion-desc pt-2">
                            <ng-container [ngSwitch]="partnerName">
                                <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                    <ul class="has-dot mb-0">
                                        <li>Eine Behandlung mit medizinischem Cannabis erfolgt individuell. Das Behandlungsziel ist eine zufriedenstellende Wirkung bei gleichzeitig möglichst geringen Nebenwirkungen. Für Cannabisextrakte hilft es, sich an einer genauen Dosierung zu orientieren, die Ihnen von Ihrem Arzt zur Verfügung gestellt wird. Die Einnahmezeitpunkte sowie die Einnahmebedingungen (z. B. während der Mahlzeiten oder nüchtern) sollten möglichst immer gleich gehalten werden.</li>
                                        <li>Diese Dosis wird schrittweise, je nach Bedarf, über mehrere Wochen erhöht. Wenn Sie sensibel auf eine Therapie mit dem Wirkstoff THC reagieren, wird empfohlen, die Therapie mit einer niedrigeren Dosis THC pro Tag zu beginnen. Anschließend können Sie dann die Dosis nach Absprache mit Ihrer behandelnden Ärztin/Ihrem behandelnden Arzt je nach Bedarf erhöhen.</li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                    <ul class="has-dot mb-0">
                                        <li>Dieser Titrationsplan unterstützt Sie bei der Dosierung von Cannabisextrakten zu Beginn einer Therapie mit medizinischem Cannabis.</li>
                                        <li>Eine niedrige Anfangsdosis und eine stufenweise Steigerung sind entscheidend, um Ihr individuelles Therapieziel möglichst nebenwirkungsarm zu erreichen.</li>
                                        <li>Durch die langsame Steigerung der Dosis über mehrere Tage und Beobachtung der Wirkung können Sie Ihre optimale Tagesdosis ermitteln, die individuell sehr unterschiedlich sein kann. Beachten Sie bitte, dass die hier genannte maximale Tagesdosis lediglich als Orientierung dient und nicht unbedingt erreicht werden muss.</li>
                                        <li>Besprechen Sie positive sowie mögliche negative Wirkungen bei Ihrem nächsten Termin mit Ihrem behandelnden Arzt oder Ärztin, um gemeinsam Ihren optimalen Dosisbereich zu definieren.</li>
                                        <li>Die Dosierung erfolgt entweder mit einer 1-mL-Kolbenpipette (Dosierung in Millilitern) oder Dosierpumpe (Dosierung in Anzahl Hüben). Bitte beachten Sie, dass häufig der Begriff “Tropfen” anstatt “Hübe” bei der Dosierung mit der Dosierpumpe verwendet wird.</li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                    <ul class="has-dot mb-0">
                                        <li>Dieser Titrationsplan unterstützt Sie bei der Dosierung von Cannabisextrakten zu Beginn einer Therapie mit medizinischem Cannabis.</li>
                                        <li>Eine niedrige Anfangsdosis und eine stufenweise Steigerung sind entscheidend, um Ihr individuelles Therapieziel möglichst nebenwirkungsarm zu erreichen.</li>
                                        <li>Durch die langsame Steigerung der Dosis über mehrere Tage und Beobachtung der Wirkung können Sie Ihre optimale Tagesdosis ermitteln, die individuell sehr unterschiedlich sein kann. Beachten Sie bitte, dass die hier genannte maximale Tagesdosis lediglich als Orientierung dient und nicht unbedingt erreicht werden muss.</li>
                                        <li>Besprechen Sie positive sowie mögliche negative Wirkungen bei Ihrem nächsten Termin mit Ihrem behandelnden Arzt oder Ärztin, um gemeinsam Ihren optimalen Dosisbereich zu definieren.</li>
                                        <li>Die Dosierung erfolgt entweder mit einer 1-mL-Kolbenpipette (Dosierung in Millilitern) oder Dosierpumpe (Dosierung in Anzahl Hüben). Bitte beachten Sie, dass häufig der Begriff “Tropfen” anstatt “Hübe” bei der Dosierung mit der Dosierpumpe verwendet wird.</li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <ul class="has-dot mb-0">
                                        <li>Dieser Titrationsplan unterstützt Sie bei der Dosierung von Cannabisextrakten oder Dronabinol zu Beginn einer Therapie mit medizinischem Cannabis.</li>
                                        <li>Eine niedrige Anfangsdosis und eine stufenweise Steigerung sind entscheidend, um Ihr individuelles Therapieziel möglichst nebenwirkungsarm zu erreichen.</li>
                                        <li>Durch die langsame Steigerung der Dosis über mehrere Tage und Beobachtung der Wirkung können Sie Ihre optimale Tagesdosis ermitteln, die individuell sehr unterschiedlich sein kann. Beachten Sie bitte, dass die hier genannte maximale Tagesdosis lediglich als Orientierung dient und nicht unbedingt erreicht werden muss.</li>
                                        <li>Besprechen Sie positive sowie mögliche negative Wirkungen bei Ihrem nächsten Termin mit Ihrem behandelnden Arzt oder Ärztin, um gemeinsam Ihren optimalen Dosisbereich zu definieren.</li>
                                        <li>Die Dosierung erfolgt entweder mit einer 1-mL-Kolbenpipette (Dosierung in Millilitern) oder Dosierpumpe (Dosierung in Anzahl Hüben). Bitte beachten Sie, dass häufig der Begriff “Tropfen” anstatt “Hübe” bei der Dosierung mit der Dosierpumpe verwendet wird.</li>
                                    </ul>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="bg-light-pink mb-2">
                            <div class="accordion-desc attention-desc">
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <img class="icon" src="/images/private/titration/hormosan/Attention Sign_Hormosan.svg" alt="attention.svg" />
                                        <p><strong>Bei Auftreten von unerwünschten Nebenwirkungen reduzieren Sie die Dosis bei der nächsten Einnahme um eine Stufe! Orientieren Sie sich dabei an der zuletzt eingenommenen Dosierung, die noch keine Nebenwirkungen bei Ihnen verursachte. Beobachten Sie dabei, ob die Nebenwirkungen erneut auftreten. Bitte nehmen Sie gleichzeitig Kontakt zu Ihrer behandelten Arztpraxis auf und besprechen Sie mit Ihrem Arzt bzw. Ihrer Ärztin das weitere Vorgehen. </strong></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <img class="icon" src="/images/private/420pharma/attention.svg" alt="attention.svg" />
                                        <p><strong>Bei Auftreten von unerwünschten Nebenwirkungen reduzieren Sie die Dosis bei der nächsten Einnahme um eine Stufe! Orientieren Sie sich dabei an der zuletzt eingenommenen Dosierung, die noch keine Nebenwirkungen bei Ihnen verursachte. Beobachten Sie dabei, ob die Nebenwirkungen erneut auftreten. Bitte nehmen Sie gleichzeitig Kontakt zu Ihrer behandelten Arztpraxis auf und besprechen Sie mit Ihrem Arzt bzw. Ihrer Ärztin das weitere Vorgehen. </strong></p>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <img class="icon" src="/images/private/titration/attention.svg" alt="attention.svg" />
                                        <p><strong>Bei Auftreten von unerwünschten Nebenwirkungen reduzieren Sie die Dosis bei der nächsten Einnahme um eine Stufe! Orientieren Sie sich dabei an der zuletzt eingenommenen Dosierung, die noch keine Nebenwirkungen bei Ihnen verursachte. Beobachten Sie dabei, ob die Nebenwirkungen erneut auftreten.</strong></p>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                        <div class="accordion-desc">
                            <p><strong>Therapiehinweise</strong></p>
                            <ng-container [ngSwitch]="partnerName">
                                <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                    <ul class="has-dot mb-0">
                                        <li>Die Tagesdosis wird in der Regel auf 2, mitunter auf 3 Gaben über den Tag verteilt. Der ölige Extrakt kann mit einem Stück Brot oder einem fetthaltigen Nahrungsmittel z. B. auf einem Löffel eingenommen werden. Die Wirkstoffe in medizinischem Cannabis sind fettlöslich. Daher kann die Einnahme zusammen mit einem fetthaltigen Nahrungsmittel eine schnellere Aufnahme durch den Körper begünstigen. Es wird nicht empfohlen, den öligen Cannabisextrakt mit Tee oder Wasser einzunehmen.In der Regel tritt eine spürbare Wirkung innerhalb von 30-90 Minuten nach Einnahme auf und kann 4-8 Stunden anhalten.</li>
                                        <li>Beginnen Sie die Therapie gemäß dem Titrationsplan und achten Sie auf mögliche Nebenwirkungen. Die Dosierung wird in den folgenden Tagen schrittweise erhöht, bis das gewünschte Therapieziel erreicht ist.</li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                    <ul class="has-dot mb-0">
                                        <li>Es wird empfohlen, die jeweilige Einzeldosis unmittelbar vor einer Mahlzeit am Morgen, Mittag und Abend einzunehmen. Cannabisextrakte können beispielsweise auf einem Stück Brot oder Butterkeks eingenommen werden. Die Einnahme mit Tee oder Wasser wird nicht empfohlen, da ölige Zubereitungen sich nicht mit Wasser mischen.</li>
                                        <li>In der Regel tritt eine spürbare Wirkung innerhalb von 30-90 Minuten nach Einnahme auf und kann 4-8 Stunden anhalten.</li>
                                        <li>Beginnen Sie die Therapie gemäß dem Titrationsplan und achten Sie auf mögliche Nebenwirkungen. Die Dosierung wird in den folgenden Tagen schrittweise erhöht, bis das gewünschte Therapieziel erreicht ist.</li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                    <ul class="has-dot mb-0">
                                        <li>Es wird empfohlen, die jeweilige Einzeldosis unmittelbar vor einer Mahlzeit am Morgen, Mittag und Abend einzunehmen. Cannabisextrakte können beispielsweise auf einem Stück Brot oder Butterkeks eingenommen werden. Die Einnahme mit Tee oder Wasser wird nicht empfohlen, da ölige Zubereitungen sich nicht mit Wasser mischen.</li>
                                        <li>In der Regel tritt eine spürbare Wirkung innerhalb von 30-90 Minuten nach Einnahme auf und kann 4-8 Stunden anhalten.</li>
                                        <li>Beginnen Sie die Therapie gemäß dem Titrationsplan und achten Sie auf mögliche Nebenwirkungen. Die Dosierung wird in den folgenden Tagen schrittweise erhöht, bis das gewünschte Therapieziel erreicht ist.</li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <ul class="has-dot mb-0">
                                        <li>Es wird empfohlen, die jeweilige Einzeldosis unmittelbar vor einer Mahlzeit am Morgen, Mittag und Abend einzunehmen. Dronabinol oder Cannabisextrakte können beispielsweise auf einem Stück Brot oder Butterkeks eingenommen werden. Die Einnahme mit Tee oder Wasser wird nicht empfohlen, da ölige Zubereitungen sich nicht mit Wasser mischen.</li>
                                        <li>In der Regel tritt eine spürbare Wirkung innerhalb von 30-90 Minuten nach Einnahme auf und kann 4-8 Stunden anhalten.</li>
                                        <li>Beginnen Sie die Therapie gemäß dem Titrationsplan und achten Sie auf mögliche Nebenwirkungen. Die Dosierung wird in den folgenden Tagen schrittweise erhöht, bis das gewünschte Therapieziel erreicht ist.</li>
                                    </ul>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-section table-starten-section">
                <div class="table-heading">Tagesplan für die Dosierung mit {{dorierungType}}</div>
                <div class="table-responsive scrollbar">
                    <table class="table table-sm table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th class="tag">TAG</th>
                                <th class="morgens">
                                    <div>
                                        <span>MORGENS</span>
                                        <img class="icon" src="/images/private/titration/Morgens.svg" alt="Morgens.svg" />
                                    </div>
                                </th>
                                <th class="mittags" *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                    <div>
                                        <span>MITTAGS</span>
                                        <img class="icon" src="/images/private/titration/Mittags.svg" alt="Mittags.svg" />
                                    </div>
                                </th>
                                <th class="abends">
                                    <div>
                                        <span>ABENDS</span>
                                        <img class="icon" src="/images/private/titration/Abends.svg" alt="Abends.svg" />
                                    </div>
                                </th>
                                <th class="zurnacht" *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                    <div>
                                        <span>ZUR NACHT</span>
                                        <img class="icon" src="/images/private/titration/Zur Nacht.svg" alt="Zur Nacht.svg" />
                                    </div>
                                </th>
                                <th class="thcd">THC/Tag</th>
                                <th class="anmerkungen">Anmerkungen</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of werteFurDiagrammListForTotalTag">
                                <td class="tag">{{data.tag}}</td>
                                <td>{{data.morgensText}}</td>
                                <td *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY">{{data.mittagsText}}</td>
                                <td>{{data.abendsText}}</td>
                                <td *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY">{{data.zurnachtText}}</td>
                                <td class="thcd">{{data.thcd}}</td>
                                <td class="anmerkungen"></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th class="tag"></th>
                                <th class="morgens"></th>
                                <th class="mittags" *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY"></th>
                                <th class="abends"></th>
                                <th class="zurnacht" *ngIf="partnerName != PartnerNamesEnum.DOSIS_EQ_TILRAY"></th>
                                <th class="thcd"></th>
                                <th class="anmerkungen"></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="unterschrift-section">
                <p>Ort, Datum, Unterschrift</p>
            </div>
        </div>
    </div>
</div>


<ng-template #infoIcon>
    <img src="/images/medizinisches/Info Icon grey.svg" alt="Info Icon grey.svg">
    <ng-container [ngSwitch]="partnerName">
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
            <img src="/images/private/titration/tilray/Info.svg" alt="Info Icon.svg">
        </ng-container>
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
            <img src="/images/private/titration/hormosan/Info.svg" alt="Info Icon.svg">
        </ng-container>
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
            <img src="/images/private/420pharma/Info.svg" alt="Info Icon.svg">
        </ng-container>
        <ng-container *ngSwitchDefault>
            <img src="/images/medizinisches/Info Icon blue.svg" alt="Info Icon.svg">
        </ng-container>
    </ng-container>
</ng-template>
